import React from 'react'
import './style.scss'
import { useLanguage } from '../../i18n'
import { FaBalanceScale, FaUsers, FaTrophy, FaComments, FaClock, FaLock } from 'react-icons/fa'

const features = [
    {
        Icon: FaBalanceScale,
        titleKey: 'whyChooseUs.expertCounsel',
        descKey: 'whyChooseUs.expertCounselDesc'
    },
    {
        Icon: FaUsers,
        titleKey: 'whyChooseUs.clientCentric',
        descKey: 'whyChooseUs.clientCentricDesc'
    },
    {
        Icon: FaTrophy,
        titleKey: 'whyChooseUs.provenTrack',
        descKey: 'whyChooseUs.provenTrackDesc'
    },
    {
        Icon: FaComments,
        titleKey: 'whyChooseUs.transparent',
        descKey: 'whyChooseUs.transparentDesc'
    },
    {
        Icon: FaClock,
        titleKey: 'whyChooseUs.availability',
        descKey: 'whyChooseUs.availabilityDesc'
    },
    {
        Icon: FaLock,
        titleKey: 'whyChooseUs.confidentiality',
        descKey: 'whyChooseUs.confidentialityDesc'
    }
]

const WhyChooseUs = () => {
    const { t } = useLanguage();

    return (
        <section className="whyChooseUsArea">
            <div className="container">
                <div className="sectionHeader">
                    <span className="subTitle">{t('whyChooseUs.subtitle')}</span>
                    <h2>{t('whyChooseUs.title')}</h2>
                </div>

                <div className="row">
                    {features.map((feature, index) => {
                        const IconComponent = feature.Icon;
                        return (
                            <div className="col-lg-4 col-md-6 col-12" key={index}>
                                <div className="featureCard">
                                    <div className="iconWrapper">
                                        <IconComponent />
                                    </div>
                                    <div className="content">
                                        <h4>{t(feature.titleKey)}</h4>
                                        <p>{t(feature.descKey)}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    )
}

export default WhyChooseUs
